// React imports
import useClaims from "./useClaims";

export interface StripeData {
	customerPortalUrl?: URL;
}

// import Stripe from 'stripe';

// const stripe = new Stripe('your-secret-company-key-here');

// // Cancel a subscription immediately
// async function cancelSubscription(customerSubscriptionId: string) {
//   try {
//     const canceledSubscription = await stripe.subscriptions.cancel(subscriptionId);
//     console.log('Subscription canceled:', canceledSubscription.id);
//     return canceledSubscription;
//   } catch (error) {
//     console.error('Error canceling subscription:', error);
//     throw error;
//   }
// }
// async function scheduleSubscriptionCancellation(subscriptionId: string) {
//   try {
//     const updatedSubscription = await stripe.subscriptions.update(subscriptionId, {
//       cancel_at_period_end: true,
//     });
//     console.log('Subscription scheduled for cancellation:', updatedSubscription.id);
//     return updatedSubscription;
//   } catch (error) {
//     console.error('Error scheduling subscription cancellation:', error);
//     throw error;
//   }
// }
// -----
// import Stripe from 'stripe';

// const stripe = new Stripe('your-secret-key-here');

// // Change subscription to a different price/plan
// async function changeSubscriptionPlan(subscriptionId: string, newPriceId: string) {
//   try {
//     const updatedSubscription = await stripe.subscriptions.update(subscriptionId, {
//       items: [
//         {
//           id: 'existing-subscription-item-id', // You need to get this from the current subscription
//           price: newPriceId,
//         },
//       ],
//       proration_behavior: 'always_invoice', // Options: 'always_invoice', 'create_prorations', 'none'
//     });

//     console.log('Subscription updated:', updatedSubscription.id);
//     return updatedSubscription;
//   } catch (error) {
//     console.error('Error updating subscription:', error);
//     throw error;
//   }
// }

function convertUnknownToString(input: unknown): string | undefined {
	if (input === undefined) return undefined;

	if (typeof input === "string") {
		return input; // Type of 'input' is narrowed to 'string' here
	}
	// Handle cases where 'input' is not a string (e.g., throw an error, return a default string)
	throw new Error("Input is not a string");
}

const useStripe = () => {
	const userClaims = useClaims();

	const stripeCustomerEmailClaim: string | undefined = convertUnknownToString(
		userClaims?.stripe_customer_email
	);
	// Use the user's email in GIP as a fallback
	const prefilledEmail: string =
		typeof stripeCustomerEmailClaim === "string"
			? stripeCustomerEmailClaim
			: (convertUnknownToString(userClaims?.email) ?? "");

	const customerPortalUrl = new URL(
		process.env.REACT_APP_STRIPE_CUSTOMER_PORTAL_URL ??
			window.location.toString()
	);

	customerPortalUrl.searchParams.set("prefilled_email", prefilledEmail);

	return {
		customerPortalUrl: customerPortalUrl
	} as StripeData;
};

export default useStripe;
